/**
 * Search: log the query to the ANY API server, then hand the visitor to
 * DuckDuckGo for the results themselves.
 *
 * "Redirect" was chosen over embedding because DuckDuckGo blocks iframes
 * (X-Frame-Options: SAMEORIGIN + CSP frame-ancestors 'self').
 *
 * Logging uses navigator.sendBeacon so the request survives the navigation
 * away from the page. The body is JSON sent as text/plain, which keeps the
 * request "simple" per the CORS spec — no preflight OPTIONS. Server side:
 * POST /api/search-log in API-server/api-server-with-searchlog.js (stores
 * query + domain + SHA-256(ip + daily salt); never the raw IP).
 *
 * Dev builds on localhost still redirect but skip the log call, so test
 * searches never pollute the client's stats.
 */

import { getEffectiveHostname } from './index';

const LOG_ENDPOINT = 'https://any-dns.co.uk/aw_api/api/search-log';
const DDG_ENDPOINT = 'https://duckduckgo.com/';

const isLocalDev = () => {
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h === '::1';
};

export function logSearch(query) {
  if (!query || isLocalDev()) return;
  try {
    const payload = JSON.stringify({
      domain: getEffectiveHostname(),
      query,
      referer: window.location.href,
      ts: new Date().toISOString(),
    });
    if (typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(LOG_ENDPOINT, new Blob([payload], { type: 'text/plain' }));
    } else {
      fetch(LOG_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: payload,
        keepalive: true,
        mode: 'no-cors',
      }).catch(() => { /* logging must never block search */ });
    }
  } catch (e) {
    /* swallow — a failed log call must never block the redirect */
  }
}

export function submitSearch(query) {
  const q = (query || '').trim();
  if (!q) return false;
  logSearch(q);
  window.location.assign(DDG_ENDPOINT + '?q=' + encodeURIComponent(q));
  return true;
}

/** DDG target for a query — used by the results page's fallback link/button */
export function ddgUrl(query) {
  return DDG_ENDPOINT + '?q=' + encodeURIComponent((query || '').trim());
}
